// 创建人：寒立
// 功能：时间拼接
function getzf(num) {
  if (parseInt(num) < 10) {
    num = "0" + num;
  }
  return num;
}
function getMyDate(str) {
  var oDate = new Date(str),
    oYear = oDate.getFullYear(),
    oMonth = oDate.getMonth() + 1,
    oDay = oDate.getDate(),
    oHour = oDate.getHours(),
    oMin = oDate.getMinutes(),
    oSen = oDate.getSeconds(),
    oTime =
      oYear +
      "-" +
      getzf(oMonth) +
      "-" +
      getzf(oDay) +
      " " +
      getzf(oHour) +
      ":" +
      getzf(oMin) +
      ":" +
      getzf(oSen); //最后拼接时间
  return oTime;
}

// 年月日时分秒，组成的数组
function getNowDate(val) {
  var oDate = new Date();
  let num = val ?? 0;
  oDate.setTime(oDate.getTime() + 3600 * 1000 * 24 * num);
  let oYear = oDate.getFullYear(),
    oMonth = getzf(oDate.getMonth() + 1),
    oDay = getzf(oDate.getDate()),
    oHour = getzf(oDate.getHours()),
    oMin = getzf(oDate.getMinutes()),
    oSen = getzf(oDate.getSeconds());
  var arr = [oYear, oMonth, oDay, oHour, oMin, oSen];
  return arr;
}
// this.$timeFun.getNowDate
export default {
  getMyDate,
  getNowDate
};
